export default __webpack_public_path__ + "static/media/logo_novo_final_w.2b763062.png";